<template>
  <div>
    <vxe-grid
      resizable
      :data="list"
      :columns="columns" />
  </div>
</template>

<script>
import WindowsMixin from '@/mixins/windows'
import ListMixin from '@/mixins/list'

export default {
  name: 'DbStats',
  mixins: [WindowsMixin, ListMixin],
  props: {
    getParams: {
      type: Object,
    },
    data: {
      type: Object,
      required: true,
    },
  },
  data () {
    return {
      list: [],
      columns: [
        {
          field: 'key',
          title: 'Key',
          sortable: true,
        },
        {
          field: 'value',
          title: 'Value',
          sortable: true,
        },
      ],
    }
  },
  created () {
    this.fetchData()
  },
  methods: {
    async fetchData () {
      try {
        const response = await new this.$Manager('stats/db_stats', 'v1').list({
          params: {
            service: this.data.type,
          },
        })
        const list = response.data?.db_stats || {}
        const keys = Object.keys(list)
        this.list = keys.map(key => {
          return {
            key: key,
            value: list[key],
          }
        })
      } catch (error) {
        this.$Message.error(error.message)
      }
    },
  },
}
</script>
